import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SignInPageComponent } from './pages/sign-in-page/sign-in-page.component';
import { PasswordEntryPageComponent } from './pages/password-entry-page/password-entry-page.component';
import { RegistrationPageComponent } from './pages/registration-page/registration-page.component';
import { InvalidEmailPageComponent } from './pages/invalid-email-page/invalid-email-page.component';
import { SignInRedirectorComponent } from './pages/sign-in-redirector/sign-in-redirector.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { SignOutPageComponent } from './pages/sign-out-page/sign-out-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { PageGreeting } from './models/page-greeting.model';

// Every page shares the sign-in look: the light background and the flow's greeting (see
// PageGreeting). Children inherit this data from the componentless parent and override `greeting`.
// KEEP IN SYNC with the pre-boot shell in src/index.html.
const signInGreeting: PageGreeting = { dark: 'Welcome,', gold: "let's sign you in." };
const registerGreeting: PageGreeting = {
  dark: 'Welcome,',
  gold: "let's get you registered.",
  subheader: 'Your financial future, at your fingertips.',
  paragraph: "With one click you will have a bird's-eye view of your investments, making it easier, simpler, and faster.",
};
const signOutGreeting: PageGreeting = { dark: 'Goodbye,', gold: "we're signing you out." };

const routes: Routes = [
  { path: '', data: { colorScheme: { background: 'light', sections: 'white', controls: 'light' }, greeting: signInGreeting }, children: [
    { path: 'sign-in-redirect', component: SignInRedirectorComponent },
    { path: 'sign-in', component: SignInPageComponent, data: { controlStyle: 'squared' } },
    { path: 'sign-out', component: SignOutPageComponent, data: { greeting: signOutGreeting } },
    { path: 'signin-oidc', component: SignOutPageComponent, data: { greeting: signOutGreeting } },
    { path: 'password', component: PasswordEntryPageComponent, data: { greeting: null } },
    { path: 'register', component: RegistrationPageComponent, data: { controlStyle: 'squared', greeting: registerGreeting } },
    { path: 'forgot-password', component: ForgotPasswordPageComponent, data: { controlStyle: 'squared', greeting: null } },
    { path: 'invalid-email', component: InvalidEmailPageComponent },
    { path: 'auth-error', component: ErrorPageComponent },
    // IdentityServer's UserInteraction.ErrorUrl (Startup.cs)
    { path: 'error', component: ErrorPageComponent },
    {
      path: 'account', children: [
        { path: 'login', component: SignInRedirectorComponent },
      ]
    },
    { path: '', component: HomeComponent, pathMatch: 'full' },
    // Server-side errors are re-executed into the SPA at the original URL (e.g. /external/callback)
    { path: '**', component: ErrorPageComponent },
  ] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
